import Marquee from "react-fast-marquee";

export default function EditorialMarquee({ dark = false }) {
  const items = [
    "PERSONNALISATION PREMIUM",
    "B2B & STARTUPS",
    "QUALITÉ SUPÉRIEURE",
    "DEVIS EN 24H",
    "LOGO BRODÉ · SÉRIGRAPHIE",
  ];
  return (
    <div
      className={`border-y ${dark ? "bg-[#0a0a0a] text-white border-white/10" : "bg-[#ebebea] text-black border-black/10"} py-5`}
      data-testid="marquee"
    >
      <Marquee speed={40} gradient={false}>
        {[...items, ...items].map((t, i) => (
          <span key={i} className="mx-8 font-mono text-sm uppercase tracking-[0.2em] flex items-center gap-8">
            {t}
            <span className="text-[#0044ff]">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
